var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.284 -232.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 458.49 388.14)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1779.3-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.5089)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1756.5-558.9q-0.068 3.9876-2.0052 5.97-1.9369 1.9596-5.9245 1.9596h-8.7728q-7.9525 0-7.9525-7.9297v-1.9596h4.5801v1.7318q0 1.8457 0.8203 2.7116 0.8203 0.86589 2.6888 0.86589h8.4766q1.8685 0 2.6888-0.86589 0.8203-0.86588 0.8203-2.7116v-4.3978q0-1.8457-0.8203-2.6888-0.8203-0.86589-2.6888-0.86589h-15.632v-16.566h22.878v4.6712h-18.206v7.3372h11.12q4.0104 0 5.9701 1.9596 1.9596 1.9368 1.9596 5.9701z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5467966297076ae1a9aa94b8f9f5f893.svg";
export { ForwardRef as ReactComponent };